import{Fragment as n,jsx as t}from"react/jsx-runtime";function i(){return t(n,{children:t("ambientLight",{intensity:1.2*Math.PI})})}export{i as a};
